// Moderation-check detection for the Xano BrontoY endpoints that now run
// content moderation: POST /posts (BrontoY_Posts), POST /different-view/{post_id}
// (BrontoY_Posts) and POST /posts/{post_id}/replies (BrontoY_Replies).
//
// A flagged submission can come back either as an explicit flag field on the
// payload, or as an error (HTTP 4xx / Xano "Throw Error" envelope) whose
// message references moderation / guidelines — match both shapes so a
// backend wording tweak doesn't silently downgrade the warning to a
// generic toast.
//
// 1:1 port of iOS `mobile/src/lib/xano/moderation.ts` (spec 11).

export const MODERATION_MESSAGE =
  "This content can\u2019t be shared because it may violate BrontoY\u2019s Community Guidelines.";

export function isModerationFlagged(payload) {
  if (!payload || typeof payload !== "object") return false;
  return (
    payload.flagged === true ||
    payload.is_flagged === true ||
    payload.moderation_flagged === true ||
    payload.moderation?.flagged === true ||
    payload.moderation_status === "flagged" ||
    payload.status === "flagged"
  );
}

export function isModerationError(e) {
  const data = e?.response?.data;
  if (
    isModerationFlagged(data) ||
    isModerationFlagged(data?.payload) ||
    isModerationFlagged(e?.xanoEnvelope?.payload)
  ) {
    return true;
  }
  const text = [
    e?.message,
    typeof data === "string" ? data : data?.message,
    data?.error,
    data?.code,
    typeof data?.payload === "string" ? data.payload : data?.payload?.message,
  ]
    .filter((s) => typeof s === "string")
    .join(" ")
    .toLowerCase();
  return /moderat|flagged|guideline|violat|inappropriate|unsafe content|content polic/.test(
    text
  );
}
